import { z } from 'zod';
export const PatchApplicationIntentSchema = z
    .object({
    status: z.enum(['initiated', 'completed']),
    email: z.string().email().optional().nullable(),
    firstName: z.string().optional().nullable(),
    lastName: z.string().optional().nullable()
})
    .required();
//# sourceMappingURL=patchApplicationIntentSchema.js.map